(function(){
    'use strict';

    angular.module('tmx-common')
        .directive('tmxSidenavsearch', [tmxSidenavsearch]);

    function tmxSidenavsearch() {

        var directive={
            restrict: 'E',
            scope: {
                model: '=',
                onSubmit:"&",
                kendoRead:"&",
                service: "=",
                focus: "@",
                clear:"@",
                clearData:'='
                
            },

            templateUrl: 'common/directives/tmxSidenavsearch/tmxSidenavsearch.html',
            controller: ["$scope","$timeout","$rootScope",tmxSidenavsearchCtrl],
            controllerAs:'tmxSidenavsearchCtrl'
        };

        return directive;
    }

    function tmxSidenavsearchCtrl($scope,$timeout,$rootScope){
        var sideNav=this;
        sideNav.scope=$scope;
        sideNav.searchdisable = false
        var service = angular.copy( sideNav.scope.service);
        if(sideNav.scope.service != null)
            for (var i = 0 ; i < sideNav.scope.service.length;i++) {
                if(sideNav.scope.service[i].search == undefined || sideNav.scope.service[i].search == null) {
                    sideNav.scope.service[i].search = true;
                }
                if(sideNav.scope.service[i].usePattern == undefined || sideNav.scope.service[i].usePattern == null) {
                    sideNav.scope.service[i].usePattern = true;
                }
            }

        ////////////////////////////////FUNCTIONS////////////////////////////////////////////////////////////////////////
        sideNav.search = function(navID) {
           
            var calls=[];
            var calls2=[];
            var calls3=[];
            sideNav.date = new Date().toJSON();
            var arr = sideNav.date.split("T");
            var arr2 = arr[1].split(":");
            arr2[0] = (Number(arr2[0]) + 5).toString();
            sideNav.date = arr[0] + "T" + arr2[0] + ":" + arr2[1] + ":" + arr2[2];
            sideNav.logic = "and";
            sideNav.logic2 = "or";

            for (var key in sideNav.scope.searchData) {
                if (sideNav.scope.searchData.hasOwnProperty(key)) {

                        
                    $rootScope.InitiatePage = false;
                   
                    var operator = "contains";
                    var addThis = true;
                    for (var i = sideNav.scope.service.length - 1; i >= 0; i--) {
                        if(key==sideNav.scope.service[i].field) {
                            if(sideNav.scope.service[i].type=="number") {
                                operator="gte";
                            }
                            else if(sideNav.scope.service[i].type=="integer" || sideNav.scope.service[i].type=="decimal" || sideNav.scope.service[i].type=="amount") {
                                operator="eq";
                            }
                            else if(sideNav.scope.service[i].type=="integer" && key=="PjpClusterCount"){
                                operator="eq";

                            }
                            else if(sideNav.scope.service[i].type=="numeric"){
                                operator="contains";

                            }
                            else if(sideNav.scope.service[i].type=="select" && angular.isDefined(sideNav.scope.service[i].isNumber)) {
                                if( sideNav.scope.service[i].isNumber==true) {
                                    operator="eq";
                                }
                            }
                            else if(sideNav.scope.service[i].type=="select" && angular.isDefined(sideNav.scope.service[i].isBool)) {
                                if(sideNav.scope.service[i].isBool==true && (checkvalue(key)=='1' || checkvalue(key)=='0')) {
                                    calls.push({
                                        field:  key,
                                        operator:"eq",
                                        value: (checkvalue(key)=='1') ? true:false //sideNav.scope.searchData[key]
                                    });
                                    addThis = false;
                                }
                                else if(sideNav.scope.service[i].isBool==true && (checkvalue(key)=='true' || checkvalue(key)=='false')) {
                                    calls.push({
                                        field:  key,
                                        operator:"eq",
                                        value: (checkvalue(key)=='true') ? true:false //sideNav.scope.searchData[key]
                                    });
                                    addThis = false;
                                }
                            }
                            else if(sideNav.scope.service[i].type=="select" && angular.isDefined(sideNav.scope.service[i].searchVisible) && checkvalue(key)!=undefined) {
                                if(sideNav.scope.service[i].searchVisible==true ) {
                                    calls.push({
                                        field:  key,
                                        operator:"eq",
                                        value:  getVissibleValue(sideNav.scope.service[i].data,checkvalue(key))//sideNav.scope.searchData[key]
                                    });
                                    addThis = false;
                                }
                            }
                            else if(checkvalue(key) && (sideNav.scope.service[i].type=="date" && checkvalue(key).valueOf() != '' )) {
                                var date=angular.copy(checkvalue(key));
                                    // This is introduced to handle the range "applySearchRangeForThisDate"
                                    //sideNav.scope.service[i].applySearchRangeForThisDate == true
                                    // var selectedDate = angular.copy(checkvalue(key));
                                var selectedDateStart,selectedDateEnd;

                                selectedDateStart = angular.copy(new Date(date));
                                selectedDateEnd = angular.copy(new Date(date));

                                if (angular.isDefined(sideNav.scope.service[i].applySearchRangeForThisDate) && 
                                        sideNav.scope.service[i].applySearchRangeForThisDate == true) {

                                    selectedDateStart.setDate(selectedDateStart.getDate());
                                    selectedDateEnd.setDate(selectedDateEnd.getDate() + 1);

                                    calls.push({
                                        field: key,
                                        operator: "gte",
                                        value:(selectedDateStart.toJSON()).replace('Z','')
                                    });

                                    calls.push({
                                        field: key,
                                        operator: "lt",
                                        value: (selectedDateEnd.toJSON()).replace('Z','')
                                    });
                                        
                                    addThis = false;
                                }  
                                else if(angular.isDefined(sideNav.scope.service[i].operator)){
                                    if(sideNav.scope.service[i].operator=="lte"){
                                        var EndDate = angular.copy(new Date(date));
                                        EndDate.setDate(EndDate.getDate() + 1);
                                        date = EndDate;
                                    }
                                    calls.push({
                                        field: sideNav.scope.service[i].filterfield,
                                        operator: sideNav.scope.service[i].operator,
                                        value: date.toJSON()
                                    });
                                    addThis = false;
                                }
                                else {

                                    calls.push({
                                        field: key,
                                        operator: "eq",
                                        value: JSON.stringify(date).replace(/"/g,'')
                                    });
                                    addThis = false;

                                }
                            }

                            else if(sideNav.scope.service[i].isComposite==true) {
                                sideNav.scope.searchValue = checkvalue(key);
                                if(angular.isDefined(sideNav.scope.searchData[key]) && sideNav.scope.searchData[key]!=""
                                        && sideNav.scope.searchData[key]!=null)
                                    //if(angular.isDefined(sideNav.scope.searchValue) && sideNav.scope.searchValue!="" &&
                                    //    sideNav.scope.searchValue!=null)
                                {
                                    for (var j = sideNav.scope.service[i].fields.length - 1; j >= 0; j--) {
                                        calls2.push({
                                            field:sideNav.scope.service[i].fields[j],
                                            operator: "contains",
                                            value: sideNav.scope.searchValue,//sideNav.scope.searchData[key]
                                            logic: "or"
                                        });
                                    }
                                    addThis = false;
                                }
                            }
                            if(angular.isDefined(sideNav.scope.service[i].filterOperator) && sideNav.scope.service[i].filterOperator != null){
                                operator = sideNav.scope.service[i].filterOperator;
                            }
                        }
                    }
                        
                    sideNav.scope.searchValue = checkvalue(key);

                    if (isNaN(sideNav.scope.searchValue) && sideNav.scope.searchValue!=undefined ){
                        sideNav.scope.searchValue=sideNav.scope.searchValue.replace(/["']/g,"&#39;");
                    }
                                

                    if(sideNav.scope.searchData[key]!=null && sideNav.scope.searchData[key]!="" && addThis){
                            //if(sideNav.scope.searchValue!=null && sideNav.scope.searchValue!="" && addThis){
                        calls.push({
                            field: key,
                            operator: operator,
                            value: encodeURIComponent(sideNav.scope.searchValue)
                        });
                    }


                }
            }//for end


            var calls_final = [];
            calls_final.push(calls);
            calls_final.push(calls2);
            calls_final.push(calls3);
            //debugger
            //if(calls.length > 0 || calls2.length > 0) {
            sideNav.scope.filt = {
                filters: calls,
                logic: sideNav.logic,
                compositeFilter: calls2,
                addAsOr: calls3
            };
            //}
            //else {
            //    sideNav.scope.filt = null;
            //}


            // companyVM.searchObject.data.filter=companyVM.filt;

            if( sideNav.scope.model!=undefined) {
                sideNav.scope.model.data.filter = sideNav.scope.filt;
            
            // CompanyService.getByParams(companyVM.searchObject,true).then(function(response){
            //               companyVM.container.companyGrid.dataSource.data(response.data);
            //               // companyVM.container.companyGrid.dataSource.read();
            //               // o.success(response)
            //             });
            // sideNav.container.companyGrid.dataSource.transport.read(companyVM.o);

            // sideNav.scope.searchData = {};
        
                sideNav.scope.model.read = true;
            
                sideNav.scope.model.fromSideNav = true;
                sideNav.prevReq=sideNav.scope.kendoRead({ promise: sideNav.scope.model });
                sideNav.scope.onSubmit({ promise: sideNav.scope.model });
            }

            //sideNav.prevReq.cancel(); uncomment to verify cancel is working
            // sideNav.toggle(navID);

        };

         sideNav.submit=function(navID){
         sideNav.search(navID);
         sideNav.scope.onSubmit({ promise:navID});
         }
        function getVissibleValue(data,Value) {
            for(var  i=0;i<data.length;i++) {
                if(data[i].LookupId==Value) {
                    return data[i].VisibleValue;
                }
            }
        }
        function checkvalue(key) {
            if(!angular.isDefined(sideNav.scope.searchData[key])/* || sideNav.scope.searchData[key]=="" || sideNav.scope.searchData[key]!=null || sideNav.scope.searchData[key]!="NaN"*/){
                return;
            }
            var value = sideNav.scope.searchData[key];
            var newvalue = value;

            if ((key.toLowerCase()).search("number") != -1 ||
                (key.toLowerCase()).search("nationalidentifiervalue") != -1 ) {//key = PhoneNumber
                // recording and replacing index values of + in phone field
                for (var i = 0; i < value.length; i++) {

                    if (newvalue.search(/[\\+]/)  != -1) {//plus exists
                        newvalue = newvalue.replace("+", "");
                    }
                    if (newvalue.search(/[\\(]/)  != -1) {//plus exists
                        newvalue = newvalue.replace("(", "");
                    }
                    if (newvalue.search(/[\\)]/)  != -1) {//plus exists
                        newvalue = newvalue.replace(")", "");
                    }
                    /*
                     COMMENTING AS - WAS USED IN LOAN APPLICATION NUMBER AND CAN BE USED IN OTHER SEARCHES S WELL
                     if (newvalue.search(/[\\-]/)  != -1) {//plus exists
                     newvalue = newvalue.replace("-", "");
                     }
                     */
                    if (newvalue.search(/[\\ ]/)  != -1) {//plus exists
                        newvalue = newvalue.replace(" ", "");
                    }
                    if (newvalue.search(/[\\/]/)  != -1) {//plus exists
                        newvalue = newvalue.replace("/", "");
                    }
                }
            }

            return newvalue;
        }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        sideNav.valueChange=function(value,type,field, colObject){           
            
            if(angular.isDefined(value)){
                // if(field.toLowerCase()=="rolename"){
                //     if(value.length==0 || value.length>=3){
                //         callSearch();
                //     }

                // }
                // else{
                if(value.length==0 || value.length>=(colObject.minlength||0)){
                    callSearch();
                }
                else if( (value.length>0 &&  type=='integer') || type == 'amount') {
                    callSearch();
                }
                //}

            }
        };

        sideNav.valueChangeDate = function(field){
            return function(value,scope){
                sideNav.valueChangeSelect(value,scope,undefined,field);
            };
        };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        sideNav.valueChangeSelect=function(value,scope,parameter,field){
            
            if(angular.isDefined(sideNav.scope.searchData) && angular.isDefined(sideNav.scope.searchData.FromDate) && angular.isDefined(sideNav.scope.searchData.ToDate)) {           
                var isCallSearch = true;
            // var value = sideNav.scope.searchData.FromDate;
                var fromDate = field == 'FromDate' ? value : sideNav.scope.searchData.FromDate;
                var toDate = field == 'ToDate' ? value : sideNav.scope.searchData.ToDate;
                if((fromDate > toDate) && toDate) {
                
                    sideNav.searchForm.ToDate.$setTouched(true);
                // sideNav.searchForm.ToDate.$setDirty(true);
                    sideNav.searchForm.ToDate.$setValidity("endLessStartDate", false);
                    sideNav.searchForm.$submitted = true;

                    isCallSearch = false;
                }
                else {
                    sideNav.searchForm.ToDate.$setValidity("endLessStartDate", true);
                    isCallSearch = true;
                }
                if(value && field=="FromDate") {                    
                // sideNav.scope.min.ToDate = new Date(value+'Z');
                    sideNav.scope.min.ToDate = new Date(value);
                }
                else {
                    sideNav.scope.min.ToDate = new Date("1-1-1899");
                }
            
                if(angular.isDefined(value) && isCallSearch){
                    callSearch();
                }
            }
            else{
                if(angular.isDefined(value)){
                    callSearch();
                }
            }
           
        };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function callSearch(){
            
            if(angular.isDefined(sideNav.prevTimeout)){
                $timeout.cancel(sideNav.prevTimeout);
                delete sideNav.prevTimeout;
            }
            cancelLastRequest();
            sideNav.prevTimeout=$timeout(sideNav.search,500);
        }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function cancelLastRequest(){
            if(angular.isDefined(sideNav.prevReq) && angular.isDefined(sideNav.prevReq.cancel)){
                sideNav.prevReq.cancel();
                delete sideNav.prevReq;
            }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// companyVM.searchDataObject = {
//       page: 1,
//       pageSize: 10,
//       skip: 0,
//       take: 10,
//       sort: undefined,
//       filter: companyVM.filt
// }

// companyVM.searchObject = {
//       data: companyVM.searchDataObject
//     };
/////////
///////////////////////////  CLEAR FUNCTION ///////////////////////////////////////////////////////////////////////////
        sideNav.clear = function(navID) {
            if(!sideNav.scope.model){
                return;
            }
            sideNav.scope.searchData = {};
            sideNav.scope.model.read = false;
            sideNav.user= angular.copy(service);
            sideNav.searchForm.$setPristine();
            sideNav.searchForm.$setValidity();
            sideNav.searchForm.$setUntouched();
          //  document.getElementById("tmxSidenavsearchCtrl.searchForm").reset();
            $(this).closest('searchForm').find("input[type=text], textarea").val("");
            // in my case I had to call $apply to refresh the page, you may also need this.


            callSearch();

            for(var i= 0;  i < sideNav.scope.service.length; i ++) {
                $('#search'+i+' input').val("");
                $('#search'+i+' md-input-container').removeClass('md-input-has-value')
                $('#search'+i+'').find("span.tmx-textbox-icon-clear").remove();

            }

            // sideNav.scope.onSubmit({ promise: sideNav.scope.model });
            // sideNav.toggle(navID);
        };

        $scope.clearData = sideNav.clear;
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////WATCH on CLEAR VALUE from Main CONTROLLER//////////////////////////////////
// To clear the fields when filter icon from grid is removed by clicking the header column/////////////////////////////
        function value(){
            return $scope.clear;
        }
        function onValueChange(newValue,oldValue){
            if(newValue == oldValue || newValue=="false"){return;}        
            if(newValue == "true" ) {
                sideNav.clear();
            }
        }
        $scope.$watch(value,onValueChange);
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    }//controller function end
})();//page end